import { useEffect, useState } from "react";
import { formatNumberID } from "../../../../../utils/FormatNumber";
import { Skeleton } from "primereact/skeleton";
import { AnimatePresence, motion } from "framer-motion";
const OwnerDashboardCustomerPackage = (props) => {
  const { data, filterValue, loading } = props;

  const [remainingPackages, setRemainingPackages] = useState([]);

  useEffect(() => {
    if (data) {
      const sortedRemainingPackages = data?.remaining_packages?.sort(
        (a, b) => b.total - a.total
      );
      const newRemainingPackages = sortedRemainingPackages?.map((item) => {
        return {
          name: item.product_name,
          qty: item.total,
          id: item.product_id,
        };
      });

      setRemainingPackages(newRemainingPackages);
    }
  }, [data]);

  const PackageItemList = ({ item, index }) => {
    const handleClick = () => {
      window.location.href = `/report/remaining-customer-packages-detail/${item.id}/${item.name}`;
    };
    return (
      <div
        className="flex items-center justify-between gap-2 w-full px-4 py-1 rounded-lg shadow-sm bg-gray-100 hover:shadow-md hover:cursor-pointer hover:translate-y-[-2px] ease-in-out duration-300"
        onClick={handleClick}
      >
        <div className="flex items-center gap-2 min-w-0">
          <span className="min-w-[2rem] min-h-[2rem] w-[2rem] h-[2rem] rounded-full flex items-center justify-center text-white text-sm font-bold bg-gradient-to-r from-purple-500 to-blue-600">
            {index + 1}
          </span>
          <div className="col-between-start gap-0.5 max-w-[150px] sm:max-w-[500px]">
            <span
              className="text-sm sm:text-md font-semibold truncate max-w-[150px] sm:max-w-[500px]"
              title={item.name}
            >
              {item.name}
            </span>
          </div>
        </div>
        <span className="text-md sm:text-lg font-bold bg-gradient-to-br from-green-400 to-emerald-500 text-transparent bg-clip-text whitespace-nowrap">
          {formatNumberID(item.qty)}
        </span>
      </div>
    );
  };

  const PackageItemSkeleton = () => {
    return (
      <div className="flex items-center justify-between gap-2 w-full px-4 py-2 rounded-lg shadow-sm bg-gray-50">
        {/* Left: Circle + Name */}
        <div className="flex items-center gap-2 min-w-0">
          <Skeleton shape="circle" width="2rem" height="2rem" />

          <Skeleton width="5rem" height="1rem" />
        </div>

        {/* Right: Number */}
        <Skeleton width="5rem" height="1rem" />
      </div>
    );
  };

  return (
    <div className="elevated-card-tight-vertical w-full col-center-start gap-4 !shadow-md border border-gray-300 !px-[1rem] sm:!px-6">
      <div className="flex flex-col items-start justify-between gap-0.5 w-full">
        <label className="row-start-center gap-2 text-xl font-semibold text-black">
          Remaining Customer Packages
        </label>
        <div className="w-full row-between-center gap-2">
          <span className="text-xs bg-gradient-to-br from-green-200 to-emerald-200 text-black font-semibold border border-green-400 rounded-md px-2 py-0.5">
            Lifetime
          </span>
          <button
            onClick={() => {
              window.open(`/report/remaining-customer-packages`, "_blank");
            }}
            className="text-sm text-slate-600 font-semibold rounded-md hover:text-slate-700 mr-1 underline"
          >
            [View all]
          </button>
        </div>
      </div>

      {/* Animated list container */}
      <div
        className={`transition-[max-height] duration-500 col-start-start w-full gap-2 max-h-[30rem]
        }`}
      >
        <AnimatePresence mode="wait">
          <motion.div
            key={loading ? "loading" : "loaded"}
            initial={{ opacity: 0, x: 0 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="col-center-start w-full gap-2"
          >
            {loading ? (
              [...Array(8)].map((_, idx) => <PackageItemSkeleton key={idx} />)
            ) : remainingPackages.length < 1 ? (
              <span className="text-lg text-black">No data available</span>
            ) : (
              remainingPackages.map((item, index) => (
                <PackageItemList key={index} item={item} index={index} />
              ))
            )}
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
};

export default OwnerDashboardCustomerPackage;
